import { useState } from "react";
import { X, Check } from "lucide-react";

import TableHead from "../../../components/UI/TableUI/TableHead";
import { machinesHeadList } from "../../../utils/TableHeadList";
import NoDataDisplay from "../../../components/UI/NoDataDisplay";
import MobileActionHeader from "../../../components/UI/headingsUI/MobileActionHeader";
import FilterSearch from "../../../components/common/FilterSearch";
import { filterCategorySearch } from "../../../utils/filterCategoryList";
import { machineSearch } from "../../../utils/tableSearchList";
import MachineViewDialog from "../dialog/MachineViewDialog";
import UsePermissionsClaim from "../../../CustomHooks/UsePermissionsClaim";
import { checkValue } from "../../../functions/checkValue";

const MachinesList = ({ machinesData }) => {
  const [machineViewDetails, setMachineViewDetails] = useState({});
  const isDataAvailable = machinesData.length > 0;
  const { checkPermission } = UsePermissionsClaim();
  const permAddMachine = checkPermission("add_machine");
  return (
    <>
      <MobileActionHeader
        title="Machines"
        navigate={"/site/add-machine"}
        btnText={permAddMachine ? "Add Machine" : undefined}
      />
      <FilterSearch
        categories={filterCategorySearch}
        searchCategories={machineSearch}
        addBtnNavigation={"/site/add-machine"}
        addBtnText={permAddMachine ? "Add Machine" : undefined}
      />
      <div className={`table-container table-height`}>
        <table className={`table ${!isDataAvailable ? "relative" : ""}`}>
          <tbody>
            <TableHead headList={machinesHeadList} />
            {isDataAvailable ? (
              <>
                {machinesData.map((data, index) => {
                  return (
                    <tr className="table-row" key={index}>
                      <td className="p-3">{data.id}</td>
                      <td className="p-3">{checkValue(data.station?.name)}</td>
                      <td className="p-3">{data.category.name}</td>
                      <td className="p-3">
                        {data.station?.isAutomation ? (
                          <Check
                            color="green"
                            className="mx-auto"
                            strokeWidth={2.5}
                          />
                        ) : (
                          <X
                            color="red"
                            className="mx-auto"
                            strokeWidth={2.5}
                          />
                        )}
                      </td>
                      <td className="p-3">
                        <button
                          className="tableViewBtn"
                          onClick={() => setMachineViewDetails(data)}
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </>
            ) : (
              <NoDataDisplay />
            )}
          </tbody>
        </table>
      </div>
      {Object.entries(machineViewDetails).length !== 0 && (
        <MachineViewDialog
          closeDialog={() => setMachineViewDetails({})}
          viewDetails={machineViewDetails}
        />
      )}
    </>
  );
};
export default MachinesList;
